export default class ShopAnnouncementBar extends HTMLElement {
    private embla: any = null

    private containerEl: HTMLElement
    private viewportEl: HTMLElement
    private prevButton: HTMLElement
    private nextButton: HTMLElement
    private closeButton: HTMLElement
    private newsletterButtons: NodeListOf<HTMLElement>

    constructor() {
        super()

        const showAnnouncementBar =
            !sessionStorage.getItem('announcementBarClosed') && Boolean(sessionStorage.getItem('announcementBarClosed') !== 'true')

        this.containerEl = this.querySelector('[data-container]') as HTMLElement
        this.viewportEl = this.querySelector('.embla__viewport') as HTMLElement
        this.prevButton = this.querySelector('button[data-announcement-carousel-prev]') as HTMLElement
        this.nextButton = this.querySelector('button[data-announcement-carousel-next]') as HTMLElement
        this.closeButton = this.querySelector('button[data-announcement-close]') as HTMLElement

        this.newsletterButtons = this.querySelectorAll('[data-newsletter-toggle]')

        this.prevButton.addEventListener('click', () => {
            this.embla.scrollPrev()
        })
        this.nextButton.addEventListener('click', () => {
            this.embla.scrollNext()
        })

        this.closeButton.addEventListener('click', () => {
            this.handleCloseButtonClick()
        })

        // Check if announcement bar should be hidden
        if (showAnnouncementBar) {
            this.containerEl.classList.remove('hidden')
        }

        if (this.newsletterButtons) {
            this.newsletterButtons.forEach((button) => {
                button.addEventListener('click', () => {
                    window.dispatchEvent(new CustomEvent('newsletter:toggle', { bubbles: true, detail: { open: true } }))
                })
            })
        }

        ;(window as any).dispatchEvent(new CustomEvent('announcement:update', { detail: { show: showAnnouncementBar }, bubbles: true }))
    }

    private handleCloseButtonClick(): void {
        sessionStorage.setItem('announcementBarClosed', 'true')
        ;(window as any).dispatchEvent(new CustomEvent('announcement:update', { detail: { show: false }, bubbles: true }))
        this.containerEl.classList.add('hidden')
    }

    connectedCallback() {
        if (this.viewportEl) {
            import('embla-carousel').then((EmblaCarousel) => {
                this.embla = EmblaCarousel.default(this.viewportEl, {
                    loop: true,
                    align: 'center',
                    skipSnaps: false,
                    duration: 25,
                })
            })
        }
    }

    disconnectedCallback() {
        if (this.embla) {
            this.embla.destroy()
        }
    }
}

customElements.define('shop-announcement-bar', ShopAnnouncementBar)
